(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Live search */
  function initSearch() {
    var indexEl = document.getElementById('gc-guides-search-index');
    var inputs = document.querySelectorAll('[data-gc-guides-search]');
    if (!inputs.length) return;

    var index = [];
    if (indexEl) {
      try { index = JSON.parse(indexEl.textContent); } catch (e) {}
    }

    inputs.forEach(function (input) {
      var resultsEl = input.closest('.gc-guides__search-wrap')
        ? input.closest('.gc-guides__search-wrap').querySelector('[data-gc-guides-search-results]')
        : null;

      function filterCards(q) {
        var cards = document.querySelectorAll('[data-guide-card]');
        var term = q.trim().toLowerCase();
        cards.forEach(function (card) {
          if (!term) {
            card.classList.remove('is-hidden');
            return;
          }
          var hay = [
            card.getAttribute('data-guide-title'),
            card.getAttribute('data-guide-category'),
            card.getAttribute('data-guide-tags'),
            card.getAttribute('data-guide-keywords')
          ].join(' ').toLowerCase();
          card.classList.toggle('is-hidden', hay.indexOf(term) === -1);
        });
      }

      function showResults(q) {
        if (!resultsEl || !index.length) return;
        var term = q.trim().toLowerCase();
        if (term.length < 2) {
          resultsEl.hidden = true;
          resultsEl.innerHTML = '';
          return;
        }
        var hits = index.filter(function (item) {
          var hay = (item.title + ' ' + (item.excerpt || '') + ' ' + (item.category || '') + ' ' + (item.keywords || '') + ' ' + (item.tags || []).join(' ')).toLowerCase();
          return hay.indexOf(term) !== -1;
        }).slice(0, 8);

        if (!hits.length) {
          resultsEl.innerHTML = '<p class="gc-guides__search-hit" style="color:var(--g-muted)">No guides found</p>';
        } else {
          resultsEl.innerHTML = hits.map(function (h) {
            return '<a class="gc-guides__search-hit" href="' + h.url + '"><span class="gc-guides__search-hit-title">' + h.title + '</span><span class="gc-guides__search-hit-meta">' + (h.category || '') + '</span></a>';
          }).join('');
        }
        resultsEl.hidden = false;
      }

      input.addEventListener('input', function () {
        var q = input.value;
        filterCards(q);
        showResults(q);
      });

      document.addEventListener('click', function (e) {
        if (resultsEl && !input.contains(e.target) && !resultsEl.contains(e.target)) {
          resultsEl.hidden = true;
        }
      });
    });
  }

  /* Table of contents */
  function initToc() {
    var content = document.querySelector('[data-gc-guides-content]');
    var toc = document.querySelector('[data-gc-guides-toc]');
    var list = document.querySelector('[data-gc-guides-toc-list]');
    if (!content || !toc || !list) return;

    var headings = content.querySelectorAll('h2, h3');
    if (!headings.length) return;

    headings.forEach(function (h, i) {
      if (!h.id) h.id = 'gc-guide-section-' + i;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      if (h.tagName === 'H3') a.className = 'toc-h3';
      li.appendChild(a);
      list.appendChild(li);
    });

    toc.hidden = false;

    if (!reduced && 'IntersectionObserver' in window) {
      var links = list.querySelectorAll('a');
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            links.forEach(function (l) { l.classList.remove('is-active'); });
            var active = list.querySelector('a[href="#' + entry.target.id + '"]');
            if (active) active.classList.add('is-active');
          }
        });
      }, { rootMargin: '-20% 0px -60% 0px', threshold: 0 });

      headings.forEach(function (h) { observer.observe(h); });
    }
  }

  /* Copy link */
  function initCopyLink() {
    document.querySelectorAll('[data-gc-copy-link]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-gc-copy-link');
        if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () {
            btn.textContent = 'Copied!';
            setTimeout(function () { btn.textContent = 'Copy link'; }, 2000);
          });
        }
      });
    });
  }

  /* FAQ schema injection from details elements */
  function injectFaqSchema() {
    var faq = document.querySelector('[data-gc-guides-faq]');
    if (!faq) return;
    var items = faq.querySelectorAll('.gc-guides-article__faq-item');
    if (!items.length) return;

    var entities = [];
    items.forEach(function (item) {
      var q = item.querySelector('summary');
      var a = item.querySelector('.gc-guides-article__faq-answer');
      if (q && a) {
        entities.push({
          '@type': 'Question',
          name: q.textContent.trim(),
          acceptedAnswer: {
            '@type': 'Answer',
            text: a.textContent.trim()
          }
        });
      }
    });

    if (!entities.length) return;
    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: entities
    });
    document.head.appendChild(script);
  }

  function init() {
    initSearch();
    initToc();
    initCopyLink();
    injectFaqSchema();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
